import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import type { FormControl } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslatePipe } from '@core/i18n-legacy';
import { NumericInputComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-evaluation-salary-field',
  templateUrl: './evaluation-salary-field.component.html',
  styleUrls: ['./evaluation-salary-field.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, NumericInputComponent, TranslatePipe],
})
export class EvaluationSalaryFieldComponent {
  public readonly control = input.required<FormControl<string | null>>();
  public readonly currencyLabel = input<string>('');
}
